<template>
  <div class="list-row">
    <div class="text-truncate">
      <div class="heading text-truncate">{{ employee.lastName }}, {{ employee.firstName }}</div>
      <div class="--sub-heading">{{ employee.employeeIdNo }}</div>
      <div class="members-status">{{ employee.employmentStatus }}</div>
    </div>
    <MDBBtn color="primary" class="text-capitalize list-btn" :ripple="false" @click.stop.prevent="handleClick('assign', employee)" v-if="!employee.isActive && !drawerBtnLoader && !drawerAllBtnLoader">
      Assign
    </MDBBtn>
    <MDBBtn
      outline="danger"
      class="text-capitalize list-btn"
      :ripple="false"
      @click.stop.prevent="handleClick('remove', employee)"
      v-else-if="employee.isActive && !drawerBtnLoader && !drawerAllBtnLoader"
    >
      Remove
    </MDBBtn>
    <MDBBtn color="light" class="text-capitalize" :ripple="false" v-if="drawerBtnLoader || drawerAllBtnLoader"><MDBSpinner size="sm" /></MDBBtn>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import { MDBBtn, MDBSpinner } from 'mdb-vue-ui-kit';

import { storeToRefs } from 'pinia';

import { PatchEmployees } from '../../../../services/ProjectTagging/PatchEmployees';
import { PostEmployees } from '../../../../services/ProjectTagging/PostEmployees';

import { checkBlankSpace } from '../../../../helpers/inputValidator';

import { useProjectTaggingStore } from '../../../../stores/projectTagging';

const projectTagging = useProjectTaggingStore();

const { projectId, drawerAllBtnLoader, drawerPagination, drawerSearch, selectedDrawerFilter } = storeToRefs(projectTagging);

defineProps({
  employee: {
    type: Object,
  },
});

const drawerBtnLoader = ref(false);

const afterHandleClick = () => {
  const params = {
    PageNumber: drawerPagination.value.currentPage,
    SearchString: drawerSearch.value ? drawerSearch.value : '',
    FilterBy: !checkBlankSpace(selectedDrawerFilter.value) ? selectedDrawerFilter.value : 'LastName',
  };

  projectTagging.getEmployeeLookup(params).then(() => {
    drawerBtnLoader.value = false;
  });
};

const handleClick = (type, employee) => {
  drawerBtnLoader.value = true;

  const params = {
    EmployeeIds: [employee.employeeId],
  };

  if (type == 'assign') {
    PostEmployees(projectId.value, params).then(() => {
      afterHandleClick();
    });
  } else {
    PatchEmployees(projectId.value, params).then(() => {
      afterHandleClick();
    });
  }
};
</script>

<style lang="scss" scoped>
.list-row {
  display: grid;
  grid-template-columns: 3fr 1fr;
  column-gap: 10px;
  align-items: center;
  padding: 12px 0;
}
.list-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.members-status {
  font-size: 12px;
  line-height: 16px;
  text-transform: capitalize;
  color: $neutral-400;
}
.btn {
  font-size: 14px;
  padding: 0 14px;
  height: 29px;
  min-width: 78px;
  &.btn-light {
    background-color: $neutral-10;
    cursor: not-allowed;
    &:active {
      &:focus {
        box-shadow: none;
      }
    }
  }
}
.heading {
  color: $neutral-800;
  + .--sub-heading {
    color: $neutral-400;
    font-size: 12px;
  }
}
</style>
